import type { HelperMessageInputProps } from '@/components/design-system/utils/helper-message.types';
import type { VueClassValue } from '@/types/vue.types';
import type { InputHTMLAttributes } from 'vue';

export type DsInputSize = 'sm' | 'md';

export interface DsBaseInputProps extends HelperMessageInputProps {
    id?: HTMLElement['id'];
    autofocus?: HTMLInputElement['autofocus'];
    label?: string;
    list?: InputHTMLAttributes['list'];
    name?: HTMLInputElement['name'];
    placeholder?: HTMLInputElement['placeholder'];
    maxlength?: HTMLInputElement['maxLength'];
    disabled?: boolean;
    readonly?: boolean;
    required?: boolean;
    /** Forces the element to present the focus outline even without true focus */
    forceFocusOutline?: boolean;
    /** usual CSS class prop for `input-wrapper` */
    inputWrapperClasses?: VueClassValue;
    inputInnerWrapperClasses?: VueClassValue;
    tabindex?: number;
    labelTooltip?: string;
}

export interface DsTextInputProps extends DsBaseInputProps {
    type: HTMLInputElement['type'];
}

export interface DsTextareaProps extends DsBaseInputProps {
    rows?: number;
    resizable?: boolean;
}

export interface DsInputLabelProps extends Pick<
    DsBaseInputProps,
    'label' | 'required' | 'id' | 'disabled' | 'labelTooltip' | 'size'
> {}

export interface DsTextInputSlots {
    input: (props: DsTextInputProps & { elementId: string; inputClass: string; hasError: boolean }) => void;
    label: (props?: { label: string; required: boolean }) => void;
    labelTooltip: () => void;
    leading: () => void;
    trailing: () => void;
    helperText: () => void;
}

export enum MaskType {
    SSN = '999-99-9999',
    EIN = '99-9999999',
    ACCOUNT_NUMBER = 'ACCOUNT_NUMBER', // account numbers are any number that needs to be masked that has no structure/separator
}

export enum MaskPlaceholder {
    SSN = '___-__-____',
    EIN = '__-_______',
}
